@if (faqsInView().length) {
<section class="faqs">
  <h3 class="title">
    FAQs
  </h3>
  <div ngbAccordion [closeOthers]="true">
    @for (item of faqsInView(); track item) {
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader>
        <button type="button" class="fw-bold" ngbAccordionButton>
          {{ item.question }}
        </button>
      </h2>
      <div ngbAccordionCollapse (click)="$event.stopPropagation()">
        <div ngbAccordionBody>
          <div [innerHTML]="item.answer"></div>
        </div>
      </div>
    </div>
    }
  </div>
</section>
}